import React, { FC } from 'react';
import { css } from 'styled-components/macro';
import { lighten } from 'polished';

const styles = {
    color1: css`
        fill: ${({ theme }) => lighten(0.1, theme.colors.background)}; ;
    `,
    color2: css`
        fill: ${({ theme }) => lighten(0.2, theme.colors.background)}; ;
    `,
    color3: css`
        fill: ${({ theme }) => theme.colors.blue.light};
    `,
};

const PersonalBranding: FC = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" {...props}>
        <title>portfolio of this website's creator, Josh Wootonn</title>
        <path
            css={styles.color1}
            d="M237.68,275.94c0,54.61-44.64,99.07-100.3,100.62-1,0-2,.05-3,.05a105.55,105.55,0,0,1-36.05-6.29C59,356.06,31,319.19,31,275.94a99.31,99.31,0,0,1,33.31-74.05,104.06,104.06,0,0,1,34.4-20.5,105.43,105.43,0,0,1,31.86-6c1.24-.05,2.5-.08,3.76-.08a105.1,105.1,0,0,1,42.58,8.93,103.19,103.19,0,0,1,22,13.16,102,102,0,0,1,21.71,23.15A98.47,98.47,0,0,1,237.68,275.94Z"
        />
        <polygon
            css={styles.color2}
            points="395.5 209.67 329.61 238.64 282.22 259.48 221.37 286.22 206.78 253 140.03 101.15 139.89 100.83 314 24.29 347.79 101.15 368.72 148.75 395.5 209.67"
        />

        <path
            css={styles.color3}
            d="M47.63,30.16A25.38,25.38,0,0,0,30,23.39a26.14,26.14,0,0,0-17.81,6.94,21.62,21.62,0,0,0-7.69,17,21.66,21.66,0,0,0,7.84,16.86A26.11,26.11,0,0,0,30.2,70.94,25.31,25.31,0,0,0,47.78,64a22,22,0,0,0,7.48-16.94A22.06,22.06,0,0,0,47.63,30.16ZM135.87,265c-9-19.62-17.52-39.42-26.26-59.12q-5.43-12.22-10.87-24.45-10.24-23.08-20.52-46.2Q70.62,118.1,63,101l-39.28.54,40.6,100.36L100.42,291c11.29,25.43,8.11,57.67-2.11,79.29a105.55,105.55,0,0,0,36.05,6.29c1,0,2,0,3-.05C156,343.11,151.3,298.81,135.87,265Z"
        />
        <path
            css={styles.color3}
            d="M347.79,101.15h-.43l-48,117.52L248.13,101.15h-37l15.09,32.47L191,215.93,140.22,101.15H98.14L186,301.89,206.78,253l34.5-81,40.94,87.45,47.39-20.84,39.11-89.89Z"
        />
    </svg>
);

export default PersonalBranding;
